// Fire-and-forget page-view beacon.
//
// keepalive lets the request survive the navigation that triggered it, and
// every failure is swallowed: analytics must never be able to break the app or
// slow a screen down.
let last = "";

export function trackView(view) {
  if (!view || view === last) return; // don't double-count a re-render
  last = view;
  try {
    fetch("/api/track", {
      method: "POST",
      headers: { "content-type": "application/json" },
      body: JSON.stringify({ view }),
      keepalive: true,
    }).catch(() => {});
  } catch {
    /* never surfaces to the person using the app */
  }
}
